
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-10 sm:mb-12">
          {/* Về chúng tôi */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6 text-white">Liên Minh Du Lịch Mỹ</h3>
            <p className="text-sm sm:text-base text-gray-400 mb-4 leading-relaxed">
              Hệ sinh thái Win-Win-Win, kết nối các đại lý và đối tác phát triển thị trường du lịch Mỹ bền vững.
            </p>
            <div className="flex gap-3 sm:gap-4">
              <a href="https://www.facebook.com/phunggiatuan" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-blue-600 hover:bg-blue-700 rounded-full transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg sm:text-xl"></i>
              </a>
              <a href="https://zalo.me/g/bjwbgr958" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-blue-500 hover:bg-blue-600 rounded-full transition-colors cursor-pointer">
                <i className="ri-message-3-fill text-lg sm:text-xl"></i>
              </a>
              <a href="https://www.youtube.com/@DuLichKhamPhaMy" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-red-600 hover:bg-red-700 rounded-full transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-lg sm:text-xl"></i>
              </a>
              <a href="https://www.facebook.com/phunggiatuan" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-pink-600 hover:bg-pink-700 rounded-full transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>

          {/* Liên hệ */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6 text-white">Liên Hệ</h3>
            <ul className="space-y-3 sm:space-y-4">
              <li className="flex items-start gap-2 sm:gap-3">
                <i className="ri-phone-fill text-blue-400 text-lg sm:text-xl mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-gray-400 text-xs sm:text-sm">Hotline</p>
                  <a href="tel:0889992466" className="text-white hover:text-blue-400 transition-colors cursor-pointer text-sm sm:text-base">
                    088-999-2466
                  </a>
                  <br />
                  <a href="https://zalo.me/0989835538" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition-colors cursor-pointer text-sm sm:text-base">
                    0989-835-538 (Zalo)
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <i className="ri-mail-fill text-blue-400 text-lg sm:text-xl mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-gray-400 text-xs sm:text-sm">Email</p>
                  <a href="mailto:info@lienminhmy.com" className="text-white hover:text-blue-400 transition-colors cursor-pointer text-sm sm:text-base break-all">
                    info@lienminhmy.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <i className="ri-global-line text-blue-400 text-lg sm:text-xl mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-gray-400 text-xs sm:text-sm">Website</p>
                  <a href="https://www.lienminhmy.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition-colors cursor-pointer text-sm sm:text-base break-all">
                    www.lienminhmy.com
                  </a>
                </div>
              </li>
            </ul>
          </div>

          {/* Văn phòng Việt Nam */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6 text-white">Văn Phòng Việt Nam</h3>
            <div className="flex items-start gap-2 sm:gap-3">
              <i className="ri-map-pin-fill text-blue-400 text-lg sm:text-xl mt-1 flex-shrink-0"></i>
              <div>
                <p className="text-sm sm:text-base text-gray-300 leading-relaxed">
                  37 Hoàng Văn Thái<br />
                  Hà Nội, Việt Nam
                </p>
              </div>
            </div>
          </div>

          {/* Văn phòng Mỹ */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6 text-white">Văn Phòng Mỹ</h3>
            <div className="flex items-start gap-2 sm:gap-3">
              <i className="ri-map-pin-fill text-blue-400 text-lg sm:text-xl mt-1 flex-shrink-0"></i>
              <div>
                <p className="text-sm sm:text-base text-gray-300 leading-relaxed">
                  721 Susan St<br />
                  Santa Ana, CA 92704<br />
                  United States
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Đường kẻ phân cách */}
        <div className="border-t border-gray-800 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-center items-center">
            <p className="text-gray-400 text-xs sm:text-sm text-center">
              © 2026 Liên Minh Du Lịch Mỹ. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
